import { useState, useEffect, useMemo, useCallback } from 'react';
import { useMsal } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-common';
import { loginRequest } from 'config/msal';

export function useApi(callback) {
  const { instance, accounts } = useMsal();

  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const account = useMemo(() => accounts?.[0], [accounts]);

  useEffect(() => {
    if (!callback) return;

    setIsLoading(true);

    instance.acquireTokenSilent({
      ...loginRequest,
      account,
    }).then(resp => {
      if (!!resp?.idToken) {
        callback({
          authToken: resp.idToken,
        }).then(resp => {
          setData(resp);
        }).catch(error => {
          console.error(error);
        }).finally(() => {
          setIsLoading(false);
        });
      }
    }).catch(error => {
      if (error instanceof InteractionRequiredAuthError) {
        instance.acquireTokenRedirect({
          ...loginRequest,
          prompt: 'login',
        });
      } else {
        setIsLoading(false);
      }
    });
  }, [callback, instance, account]);

  return { data, isLoading };
};

export function usePostApi(callback) {
  const { instance, accounts } = useMsal();

  const [isLoading, setIsLoading] = useState(false);

  const account = useMemo(() => accounts?.[0], [accounts]);

  const post = useCallback(args => new Promise((resolve, reject) => {
    setIsLoading(true);

    instance.acquireTokenSilent({
      ...loginRequest,
      account,
    }).then(resp => {
      if (!!resp?.idToken) {
        callback(args, {
          authToken: resp.idToken,
        }).then(resp => {
          resolve(resp);
        }).catch(error => {
          reject(new Error(error));
        }).finally(() => {
          setIsLoading(false);
        });
      }
    }).catch(error => {
      if (error instanceof InteractionRequiredAuthError) {
        instance.acquireTokenRedirect({
          ...loginRequest,
          prompt: 'login',
        });
      } else {
        setIsLoading(false);
      }
    });
  }), [callback, instance, account]);

  return { post, isLoading };
};
